import { publicClient, privateClient } from './client';
import { V2CategoryResource } from './V2CategoryResource';

const queryV2CategoryResource = (pub: boolean) => new V2CategoryResource(pub ? publicClient : privateClient);
export default queryV2CategoryResource;
